var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalsPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18v-2h18v2H0Zm2.425-9.6a4.058 4.058 0 0 1-1.062-1.6 5.502 5.502 0 0 1-.338-1.9c0-1.35.463-2.504 1.388-3.463C3.338.48 4.466 0 5.8 0c.6 0 1.175.108 1.725.325.55.217 1.042.533 1.475.95a4.479 4.479 0 0 1 1.475-.95A4.664 4.664 0 0 1 12.2 0c1.35 0 2.488.483 3.413 1.45C16.538 2.417 17 3.575 17 4.925c0 .65-.12 1.27-.363 1.862A4.984 4.984 0 0 1 15.6 8.375l-5.225 5.075c-.183.183-.392.32-.625.413A2.032 2.032 0 0 1 9 14c-.267 0-.517-.046-.75-.137a1.817 1.817 0 0 1-.625-.413l-5.2-5.05Zm1.4-1.4L9 12l5.2-5.025c.283-.267.492-.58.625-.938s.2-.729.2-1.112c0-.8-.27-1.483-.813-2.05a2.644 2.644 0 0 0-1.987-.85c-.367 0-.72.07-1.063.212a2.53 2.53 0 0 0-.887.613l-.55.55c-.1.1-.213.175-.338.225-.125.05-.254.075-.387.075a.942.942 0 0 1-.375-.075A1.038 1.038 0 0 1 8.3 3.4l-.55-.55a3.069 3.069 0 0 0-.888-.625A2.504 2.504 0 0 0 5.8 2c-.783 0-1.446.283-1.987.85C3.27 3.417 3 4.1 3 4.9c0 .383.067.758.2 1.125s.342.692.625.975Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsPower);
export default __webpack_public_path__ + "static/media/goals_power.defab4ba9a461eb5e4ccb241dc39cd6b.svg";
export { ForwardRef as ReactComponent };